module.exports = __webpack_public_path__ + "static/img/image3.593fa41c.png";